import SlotsGrid from '@/core/SlotsGrid'

export default {
    user: null,
    /**
     * @type {SlotsGrid}
     */
    slotsGrid: new SlotsGrid()
}
